import axios from 'axios';
import { Model } from 'survey-core';
import { SELF_SERVE_VALUE } from '../components/questionTypes/MuiAdditionalProducts';
import { ICompletePayload, ICompleteResponse } from '../types/complete';
import { OperationType } from '../types/companyDetails';

export const handleFormCompletion = async (model: Model, accountId: string) => {
  const operationType = model.getVariable('signupType');
  const isAdmin = model.getVariable('isAdmin');
  const regularSignUp = operationType === OperationType.SIGNUP;
  const { email, subscription, additionalProduct, packageType, applicationType, paymentMethod } = model.data;
  const products = [subscription];
  const taxRate = model.getVariable('taxRate');
  const discount = model.getVariable('discount');
  const userExists = Boolean(model.getVariable('userExists'));
  const hasDiscountAmount = discount && discount.amount > 0;
  let optionalParams = '';
  const subscriptionTier = model.runExpression("expandChoicesByUrl({subscription}, 'subscriptionTier')");
  const country = new URLSearchParams(window.location.search).get('country');
  const crmCorrelationId = new URLSearchParams(window.location.search).get('corrId') || undefined;

  if (additionalProduct && additionalProduct !== SELF_SERVE_VALUE) {
    products.push(additionalProduct);
  }
  if (regularSignUp && model.runExpression('getJoiningFee()') > 0) {
    products.push(model.runExpression("getJoiningFee('id')"));
  }

  if (operationType === OperationType.FOUNDATION) {
    optionalParams += '&foundation=true';
  } else if (country) {
    optionalParams += '&country=' + country;
  }

  if (crmCorrelationId) {
    optionalParams += '&corrId=' + crmCorrelationId;
  }

  const body: ICompletePayload = {
    accountId,
    operationType,
    applicationType: applicationType ? applicationType : null,
    subscriptionTier,
    email,
    products,
    taxRateId: taxRate?.isActive ? taxRate.paymentProviderRateId : null,
    successUrl: `${window.location.origin}/signup/success?email=${encodeURIComponent(
      email
    )}&userExists=${userExists}${optionalParams}`,
    cancelUrl: `${window.location.origin}/signup${isAdmin ? '?admin=true' : optionalParams.replace('&', '?')}`,
    location: packageType,
    discountCodeId: hasDiscountAmount ? discount.id : null,
    paymentMethod,
    crmCorrelationId
  };

  return axios.post<ICompleteResponse>('/api/v1/signup/checkout', body);
};

export const checkCompletionOnServer = (accountId?: string) => {
  if (!accountId) throw new Error('accountId is empty');
  const waitForCompletion: (initial?: boolean) => Promise<boolean | undefined> = async initial => {
    if (!initial) {
      await new Promise(resolve => setTimeout(resolve, 3000));
    }
    const res = await axios.get<boolean>(`/api/v1/payments/is-completed/${accountId}`);

    if (res.status !== 200) {
      return Promise.resolve(false);
    }
    if (!res.data) {
      return waitForCompletion();
    }
    return Promise.resolve(true);
  };

  return waitForCompletion(true);
};
